var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiShare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.25C17.1997 19.25 18.375 18.0747 18.375 16.625C18.375 15.1753 17.1997 14 15.75 14C14.3003 14 13.125 15.1753 13.125 16.625C13.125 18.0747 14.3003 19.25 15.75 19.25Z",
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.125C6.69975 13.125 7.875 11.9497 7.875 10.5C7.875 9.05025 6.69975 7.875 5.25 7.875C3.80025 7.875 2.625 9.05025 2.625 10.5C2.625 11.9497 3.80025 13.125 5.25 13.125Z",
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51624 11.8213L13.4925 15.3038",
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7C17.1997 7 18.375 5.82475 18.375 4.375C18.375 2.92525 17.1997 1.75 15.75 1.75C14.3003 1.75 13.125 2.92525 13.125 4.375C13.125 5.82475 14.3003 7 15.75 7Z",
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4837 5.69629L7.51624 9.17879",
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiShare2);
export default __webpack_public_path__ + "static/media/fi_share-2.ce2178ed12cf58fbe38a908c4fd1e16d.svg";
export { ForwardRef as ReactComponent };